// src/hooks/cities/useGetCities.js
import { useQuery } from "@tanstack/react-query";
import { getAllCities } from "../../api/apiCities";
import i18next from "i18next";

const useGetCities = (page = 1, perPage = 15, filters = {}) => {
    const { data, isLoading, error, refetch, isFetching } = useQuery({
        queryKey: ["cities", page, perPage, filters, i18next.language],
        queryFn: () => getAllCities(page, perPage, filters),
        keepPreviousData: true,
    });

    const cities = data?.data || [];
    const meta = data?.data?.meta || {};

    return { cities, meta, isLoading, error, refetch, isFetching };
};

export default useGetCities;